import { useState, useEffect } from "react";
import { db } from "../../firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import AddSale from "./AddSale";

const SaleList = () => {
  const [sales, setSales] = useState([]);
  const [formMode, setFormMode] = useState(false);
  const [editSale, setEditSale] = useState(null);

  const fetchSales = async () => {
    const snapshot = await getDocs(collection(db, "sales"));
    const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
    setSales(list);
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm("Видалити розпродаж?");
    if (confirmed) {
      await deleteDoc(doc(db, "sales", id));
      fetchSales();
    }
  };

  useEffect(() => {
    fetchSales();
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>Усі розпродажі</h2>

      <button
        onClick={() => {
          setFormMode(true);
          setEditSale(null);
        }}
        style={{ marginBottom: 20 }}
      >
        Додати розпродаж
      </button>

      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <th>Назва</th>
            <th>Знижка</th>
            <th>Серії</th>
            <th>Товари</th>
            <th>Автори</th>
            <th>Період</th>
            <th>Дії</th>
          </tr>
        </thead>
        <tbody>
          {sales.map((s) => (
            <tr key={s.id}>
              <td>{s.title}</td>
              <td>{s.discountPercent}%</td>
              <td>{s.appliesTo?.series?.join(", ") || "-"}</td>
              <td>{s.appliesTo?.products?.length || "-"}</td>
              <td>{s.appliesTo?.authors?.join(", ") || "-"}</td>
              <td>
                {s.startDate ? String(s.startDate).split("T")[0] : "—"} до{" "}
                {s.endDate ? String(s.endDate).split("T")[0] : "—"}
              </td>
              <td>
                <button
                  onClick={() => {
                    setFormMode(true);
                    setEditSale(s);
                  }}
                >
                  Редагувати
                </button>
                <button onClick={() => handleDelete(s.id)}>Видалити</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {formMode && (
        <AddSale
          onClose={() => {
            setFormMode(false);
            fetchSales();
          }}
          editSale={editSale}
        />
      )}
    </div>
  );
};

export default SaleList;
